import t from '~/scopes/campaign/data/metals/iron.translations'
import SECTIONS from '~/scopes/campaign/data/metals/sections.translations'

export default {
  name: t.name,
  smartphone: {
    label: t.smartphoneLabel,
  },
  whatItDoes: {
    text: t.whatItDoesText,
    sourceRefs: ['ademe2024', 'scrreenIron2025'],
  },
  extraction: [
    {
      text: t.extractionText1,
      sourceRefs: ['usgsMcs2025', 'scrreenIron2025'],
    },
  ],
  quickFact: {
    text: t.quickFactText,
    sourceRefs: ['ademe2024', 'pblEnvironmental2024', 'scrreenIron2025'],
  },
  // Displacement, water rights, child labour, gender and legal read `n/a` on the sheet.
  impacts: {
    environmental: {
      summary: {
        text: t.envSummaryText,
        sourceRefs: ['ademe2024', 'pblEnvironmental2024', 'scrreenIron2025'],
      },
      blocks: [
        {
          title: SECTIONS.environmentalWater,
          text: t.envWaterText,
          sourceRefs: ['ademe2024', 'pblEnvironmental2024', 'scrreenIron2025'],
        },
        {
          title: SECTIONS.environmentalSoil,
          text: t.envSoilText,
          sourceRefs: ['ademe2024', 'pblEnvironmental2024', 'scrreenIron2025'],
        },
        {
          title: SECTIONS.environmentalBiodiversity,
          text: t.envBiodiversityText,
          sourceRefs: ['pblEnvironmental2024', 'scrreenIron2025'],
        },
        {
          title: SECTIONS.environmentalClimate,
          text: t.envClimateText,
          sourceRefs: ['pblEnvironmental2024', 'scrreenIron2025'],
        },
      ],
    },
    human: {
      summary: {
        text: t.humanSummaryText,
        sourceRefs: ['pblEnvironmental2024', 'scrreenIron2025'],
      },
      blocks: [
        {
          title: SECTIONS.humanHealth,
          text: t.humanHealthText,
          sourceRefs: ['pblEnvironmental2024', 'scrreenIron2025'],
        },
      ],
    },
    geopolitical: {
      summary: {
        text: t.geoSummaryText,
        sourceRefs: ['usgsMcs2025', 'scrreenIron2025'],
      },
      blocks: [
        {
          title: SECTIONS.geopoliticalDug,
          text: t.geoDugText,
          sourceRefs: ['usgsMcs2025'],
        },
        {
          title: SECTIONS.geopoliticalProcessed,
          text: t.geoProcessedText,
          sourceRefs: ['usgsMcs2025'],
        },
        {
          title: SECTIONS.geopoliticalLeverage,
          text: t.geoLeverageText,
          sourceRefs: ['usgsMcs2025', 'scrreenIron2025'],
        },
      ],
    },
  },
  supplyRisk: {
    summary: {
      text: t.supplySummaryText,
      sourceRefs: ['usgsMcs2025', 'scrreenIron2025'],
    },
    blocks: [
      {
        title: SECTIONS.supplyRiskReserves,
        text: t.supplyReservesText,
        sourceRefs: ['usgsMcs2025', 'scrreenIron2025'],
      },
      {
        title: SECTIONS.supplyRiskDemand,
        text: t.supplyDemandText,
        sourceRefs: ['scrreenIron2025'],
      },
    ],
  },
  recycling: {
    summary: {
      text: t.recyclingSummaryText,
      sourceRefs: ['unepRecyclingRates2011', 'scrreenIron2025'],
    },
    blocks: [
      {
        title: SECTIONS.recyclingInput,
        text: t.recyclingInputText,
        sourceRefs: ['scrreenIron2025'],
      },
      {
        title: SECTIONS.recyclingOutlook,
        text: t.recyclingOutlookText,
        sourceRefs: [
          'ieaRecycling2024',
          'unepRecyclingRates2011',
          'scrreenIron2025',
        ],
      },
    ],
  },
  // `*` on the four scores it names; the sheet gives iron no second note.
  footnotes: [
    {
      body: [
        {
          text: t.footnote1Text1,
          sourceRefs: ['ademe2024'],
        },
      ],
      slots: [
        'environmentalScore',
        'humanScore',
        'geopoliticalScore',
        'supplyRiskScore',
      ],
    },
  ],
} as const
